import { render, staticRenderFns } from "./VehiclesCatalogTable.vue?vue&type=template&id=b68a707e"
import script from "./VehiclesCatalogTable.vue?vue&type=script&lang=js"
export * from "./VehiclesCatalogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports